import { render, staticRenderFns } from "./orderLazada.vue?vue&type=template&id=e60b888a&scoped=true"
import script from "./orderLazada.vue?vue&type=script&lang=js"
export * from "./orderLazada.vue?vue&type=script&lang=js"
import style0 from "./orderLazada.vue?vue&type=style&index=0&id=e60b888a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60b888a",
  null
  
)

export default component.exports